import React from "react";
import { ArrowUpIcon } from "@chakra-ui/icons";
import ReportCard from "../ui/ReportCard";
import query from "../../images/frame.png";

export default function QueriedReport({ report }) {
  return <ReportCard title="Queried Reports" text={report} src={query} />;
}
